import React from "react"

import styles from "./inlineHeader.module.scss"
import widont from "widont";

const InlineHeader = props => {
    return (


        <div className="module">
            <div className="wrapper">
                <div
                    className={`columns is-tablet is-0-mobile is-centered }`}
                >
                    <div
                        className={`column is-8-desktop`}
                    >
                        {props.data.header && (
                            <h2
                                className={`h--cms-title ${styles.inlineHeader}`}
                                dangerouslySetInnerHTML={{
                                    __html: widont(props.data.header),
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
)
}

export default InlineHeader
